import React from "react";
import { Trans } from "@coworker/locales";
import { RECONNECT_TIMEOUT } from "../../core/hooks/useOnline";
import { FixaToast } from "@coworker/apprestructured/src/shared/wrappers/FixaToast/FixaToast.js";

const OfflineBar = ({ isReconnecting }) => {
  const [reconnectSeconds, setReconnectSeconds] = React.useState(null);
  const timer = React.useRef(null);
  const [toastOpen, setToastOpen] = React.useState(true);
  React.useEffect(() => {
    if (isReconnecting) {
      setReconnectSeconds(RECONNECT_TIMEOUT / 1000);

      timer.current = setInterval(() => {
        setReconnectSeconds((prevSeconds) => Math.max(prevSeconds - 1, 0));
      }, 1000);
    }

    return () => {
      clearInterval(timer.current);
    };
  }, [isReconnecting]);

  return (
    <FixaToast
      isOpen={toastOpen}
      onCloseRequest={async () => {
        setToastOpen(false);
      }}
      text={
        <Trans values={{ seconds: reconnectSeconds }}>
          {isReconnecting ? "attemptingToReconnectString" : "offlineModeString"}
        </Trans>
      }
    />
  );
};

export default OfflineBar;
